module.exports = __webpack_public_path__ + "img/dqvn-currency-guide-1.bad6f0d1.png";